export default function timesService(WEEKDAYS) {
  return {
    isoDayOfTheWeekToStringDay: isoDayOfTheWeekToStringDay,
    stringDayToIsoWeekDay: stringDayToIsoWeekDay,
    getTimeRangeFromChunk: getTimeRangeFromChunk,
    getChunkTimesFromTimeRange: getChunkTimesFromTimeRange,
    adjustNextDayOverflow: adjustNextDayOverflow,
  };

  function isoDayOfTheWeekToStringDay(dayOfTheWeek) {
    return WEEKDAYS[dayOfTheWeek] ? WEEKDAYS[dayOfTheWeek] : null;
  }

  function stringDayToIsoWeekDay(stringDay) {
    var weekday = WEEKDAYS.indexOf(stringDay);

    return weekday >= 0 ? weekday : null;
  }

  /**
   * @param chunk an API time chunk (ex: { "start": 25200, "end": 46800 })
   * that expresses the time in seconds from 00:00 on a particular day
   *
   * @returns {{start: *, end: *}} object containing the start and end of the chunk in moment objects
   */
  function getTimeRangeFromChunk(chunk) {
    if (!chunk) {
      return {};
    }

    var startOfToday = moment().startOf('day'),
      start = startOfToday.clone().add(chunk.start, 'seconds'),
      end = startOfToday.clone().add(chunk.end, 'seconds');

    return {
      start: start,
      end: end,
    };
  }

  /**
   * @param timeRange a time range with start and end moment objects
   *
   * @returns {{start: *, end: *}} object containing the start and end of the chunk in seconds from 00:00 on the same day
   */
  function getChunkTimesFromTimeRange(timeRange) {
    var copy = angular.copy(timeRange),
      startOfToday,
      start,
      end;

    if (!moment.isMoment(copy.start) || !moment.isMoment(copy.end)) {
      copy.start = moment(new Date(copy.start));
      copy.end = moment(new Date(copy.end));
    }

    startOfToday = moment().startOf('day');
    start = copy.start.diff(startOfToday, 'seconds');
    end = copy.end.diff(startOfToday, 'seconds');

    return {
      start: start,
      end: end,
    };
  }

  function adjustNextDayOverflow(timeRange) {
    var copy = angular.copy(timeRange);

    if (!moment.isMoment(copy.start) || !moment.isMoment(copy.end)) {
      copy.start = moment(new Date(copy.start));
      copy.end = moment(new Date(copy.end));
    }

    if (copy.end.date() > copy.start.date()) {
      copy.end.subtract(1, 'd');
    }

    if (copy.end.isBefore(copy.start)) {
      copy.end.add(1, 'd');
    }

    return copy;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/opening-times/times.service.js